// File d'envoi des tranches audio : une à la fois, dans l'ordre, avec reprise après coupure.
// Les tranches restent en mémoire jusqu'à la clôture, pour pouvoir renvoyer celles qui manquent.

const MAX_BACKOFF_MS = 30000;

export class UploadQueue {
  constructor({ send, onChange, onError, sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms)) }) {
    this.send = send;
    this.onChange = onChange;
    this.onError = onError;
    this.sleep = sleep;
    this.blobs = new Map();
    this.pending = [];
    this.failures = 0;
    this.running = null;
  }

  get status() {
    return { pending: this.pending.length, retrying: this.failures > 0 };
  }

  push(index, blob) {
    this.blobs.set(index, blob);
    this.enqueue([index]);
  }

  enqueue(indexes) {
    indexes.filter((i) => this.blobs.has(i) && !this.pending.includes(i)).forEach((i) => this.pending.push(i));
    this.onChange?.(this.status);
    if (!this.running) {
      this.running = this.drain()
        .catch((error) => { this.error = error; this.onError?.(error); })
        .finally(() => { this.running = null; });
    }
  }

  async drain() {
    while (this.pending.length && !this.closed) {
      const index = this.pending[0];
      try {
        await this.send(index, this.blobs.get(index));
        this.pending.shift();
        this.failures = 0;
      } catch (error) {
        if (error?.fatal) throw error;
        this.failures += 1;
        this.onChange?.(this.status);
        await this.sleep(Math.min(MAX_BACKOFF_MS, 1000 * 2 ** Math.min(this.failures, 5)));
      }
      this.onChange?.(this.status);
    }
  }

  // Attend que toutes les tranches soient parties.
  async flush() {
    while (this.running) await this.running;
    if (this.error) throw this.error;
  }

  close() {
    this.closed = true;
    this.blobs.clear();
    this.pending = [];
  }
}
